import useWarehouseAlert from './hooks/useWarehouseAlert'
import Warehouse from 'components/Warehouse'
import React from 'react'

const type = process.env.REACT_APP_TYPE
const WarehouseComponent: React.FC<warehouse.Warehouse> = (props) => {
  const { name, rentableType, doorState, warehouseAnimation, warehousePhoto, warehouseTransparentPhoto } = props
  const { alert, warning } = useWarehouseAlert(props)
  const isLdz01Warehouse = type === 'ldz01' && rentableType === 'warehouse'

  return (
    <Warehouse
      name={name}
      warehouseAnimation={warehouseAnimation}
      image={(warehouseAnimation === 'custom' && (warehouseTransparentPhoto || warehousePhoto) && !isLdz01Warehouse)
        ? (warehouseTransparentPhoto || warehousePhoto)
        : undefined}
      lock={doorState?.lock}
      door={doorState?.door}
      warning={warning}
      rentableType={rentableType}
      alert={alert}
    />
  )
}

export default WarehouseComponent
